module.exports = __webpack_public_path__ + "a794ab384389fc57b7bf0c1143dbac71.svg";